import api from "./api";
export default class VendasBoletoApi {
  static postVendaDigitada = async (body: any) => {
    const response = await api.post(`/VendaBoleto`, body);
    return response.data;
  };
}
